import {
  CUSTOMER_API,
  CUSTOMER_API_REMOVE,
  CUSTOMER_API_SEARCH,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  CreateCustomerModel,
  SearchCustomerRequestModel,
  CustomerModel,
  UpdatedCustomerModel,
  CustomerAddressModel,
} from "./customer.models";

export const searchCustomer = async (
  searchCustomerRequestModel: SearchCustomerRequestModel
) => {
  const createResponse = await apiClient.postHttp<PagedResult<CustomerModel>>(
    `${CUSTOMER_API_SEARCH}`,
    searchCustomerRequestModel
  );
  return createResponse;
};

export const removeCustomer = async (
  removedModel: RemovedEntityModel<number>
) => {
  const response = await apiClient.postHttp(
    `${CUSTOMER_API_REMOVE}`,
    removedModel
  );
  return response;
};

export const getCustomerById = async (id: number) => {
  return await apiClient.getHttp<CustomerModel>(`${CUSTOMER_API}/${id}`);
};

export const addCustomer = async (model: CreateCustomerModel) => {
  const response = await apiClient.postHttp<number>(`${CUSTOMER_API}`, model);
  return response;
};

export const updateCustomer = async (model: UpdatedCustomerModel) => {
  const response = await apiClient.putHttp<number>(`${CUSTOMER_API}`, model);
  return response;
};

export const addCustomerAddressAPI = async (
  customerId: number,
  model: CustomerAddressModel
) => {
  const response = await apiClient.postHttp(
    `${CUSTOMER_API}/${customerId}/addresses`,
    model
  );
  return response;
};

export const updateCustomerAddressAPI = async (
  customerId: number,
  model: CustomerAddressModel
) => {
  const response = await apiClient.putHttp(
    `${CUSTOMER_API}/${customerId}/addresses`,
    model
  );
  return response;
};

export const removeCustomerAddressAPI = async (
  customerId: number,
  customerAddressId: number
) => {
  const response = await apiClient.deleteHttp(
    `${CUSTOMER_API}/${customerId}/addresses?addressId=${customerAddressId}`
  );
  return response;
};
